export const tr = {
  hero: {
    title: "<span>Daha Akıllıca</span> OKX + METRADE ile Ticaret Yapın",
    subtitle: "Profesyonel ticaret stratejileri artık herkes için erişilebilir",
    startTrading: "Şimdi Ticarete Başlayın",
    learnMore: "OKX Hakkında Daha Fazla Bilgi",
    poweredBy: "Destekleyen",
    socialProof: "Ticaret performanslarını artıran 50.000'den fazla tücara katılın"
  },
  promo: {
    signUp: "Bugün kaydolun ve alın",
    months: "3 AY ÜCRETSİZ",
    worth: "3x29$ değerinde • 87$ tasarruf edin",
    limitedTime: "Sınırlı süreli teklif! Yakında sona eriyor"
  },
  whyMetrade: {
    title: "Neden METRADE'i Seçmelisiniz",
    subtitle: "OKX ticaret yolculuğunuz için mükemmel ortak",
    reason1: {
      title: "Doğrulanmış Stratejiler",
      description: "Tüm premium stratejiler kanıtlanmış geçmişe sahiptir ve kapsamlı olarak incelenmiştir"
    },
    reason2: {
      title: "Risk Yönetimi",
      description: "Her premium stratejiye sermayenizi korumak için entegre edilmiş gelişmiş risk kontrolleri"
    },
    reason3: {
      title: "İsviçre Kalitesi",
      description: "Hassasiyet, güvenilirlik ve güvenlikle İsviçre'de üretilmiştir"
    },
    reason4: {
      title: "Kolay Entegrasyon",
      description: "Teknik bilgi gerektirmeden OKX hesabınızda stratejiyi takip edin"
    },
    reason5: {
      title: "Tam Şeffaflık",
      description: "Gerçek zamanlı performans verilerine ve tam ticaret geçmişine erişin"
    },
    reason6: {
      title: "Uzman Desteği",
      description: "Size yardımcı olmaya hazır profesyonellerden oluşan özel ekip"
    }
  },
  steps: {
    title: "Ticaret Yolculuğunuza Başlayın",
    subtitle: "Üç basit adımda başlayın",
    step1: {
      title: "Ücretsiz kayıt olun",
      description: "Saniyeler içinde hesabınızı oluşturun"
    },
    step2: {
      title: "Bir Strateji Seçin",
      description: "Tercih ettiğiniz ticaret stratejisini seçin"
    },
    step3: {
      title: "Bağlanın ve Başlayın",
      description: "Kılavuzlu kurulumumuzla stratejinizi seçin ve ticarete başlayın"
    },
    joinText: "METRADE'de binlerce başarılı kullanıcıya katılın"
  },
  stats: {
    title: "Kanıtlanmış Performans",
    subtitle: "Platformumuz tüccarlar için dünya çapında tutarlı sonuçlar sunar",
    activeUsers: "Aktif Kullanıcı",
    tradingVolume: "İşlem Hacmi",
    successRate: "Başarı Oranı",
    support: "Destek"
  },
  features: {
    title: "METRADE Marketplace",
    subtitle: "Ticaret deneyimlerini dönüştüren binlerce başarılı kullanıcıya katılın",
    feature1: {
      title: "Kanıtlanmış Stratejiler",
      description: "Savaşta test edilmiş ticaret stratejilerine erişin"
    },
    feature2: {
      title: "Yüksek Getiri Potansiyeli",
      description: "Ticaret potansiyelinizi maksimize edin"
    },
    feature3: {
      title: "Kullanımı Kolay",
      description: "Platformumuzla dakikalar içinde ticarete başlayın"
    },
    feature4: {
      title: "Veri Odaklı",
      description: "Analizlerle bilgilendirilmiş kararlar alın"
    }
  },
  strategyShowcase: {
    title: "En İyi Performans Gösteren Stratejiler",
    subtitle: "OKX'te mevcut en başarılı ticaret stratejilerimizi keşfedin",
    viewAll: "Tüm Stratejileri Görüntüle",
    strategy1: {
      name: "Momentum Ustası",
      description: "Hassas giriş ve çıkış noktalarıyla piyasa trendlerini yakalar",
      roi: "+187% ROI in 2023",
      winRate: "78% Kazanma Oranı",
      riskLevel: "Orta Risk"
    },
    strategy2: {
      name: "Oynaklık Avantajı",
      description: "Adaptif ticaret parametreleriyle değişken piyasalarda gelişir",
      roi: "+215% ROI in 2023",
      winRate: "82% Kazanma Oranı",
      riskLevel: "Orta-Yüksek Risk"
    },
    strategy3: {
      name: "İstikrarlı Büyüme",
      description: "Tutarlı getirilere odaklanan muhafazakar yaklaşım",
      roi: "+95% ROI in 2023",
      winRate: "91% Kazanma Oranı",
      riskLevel: "Düşük Risk"
    },
    okxCompatible: "OKX için optimize edilmiştir"
  },
  testimonials: {
    title: "Başarı Hikayeleri",
    subtitle: "Stratejilerimizden zaten faydalanan tüccarlardan duyun",
    testimonial1: {
      quote: "OKX hesabımı METRADE'e bağladığımdan beri, ticaretim tamamen değişti. Artık eskiden sürekli kayıplarla karşılaştığım yerde istikrarlı getiriler görüyorum. Otomatik stratejiler, piyasa koşullarına benim yapabileceğimden çok daha hızlı uyum sağlıyor.",
      author: "Alex K.",
      location: "Birleşik Krallık",
      strategy: ""
    },
    testimonial2: {
      quote: "OKX-METRADE entegrasyonunda beni en çok etkileyen şeffaflık. Her işlemi görebilir, performansı gerçek zamanlı olarak izleyebilir ve strateji zor işi yaparken tam kontrol sahibi olabilirim.",
      author: "Mei L.",
      location: "Singapur",
      strategy: ""
    },
    testimonial3: {
      quote: "Meşgul bir profesyonel olarak, tüm gün grafikleri analiz etmek için hiç zamanım yoktu. METRADE'in OKX'teki stratejileri, günlük işimden fedakarlık yapmadan profesyonel düzeyde uygulama ile kripto piyasalara katılmamı sağladı.",
      author: "Raj P.",
      location: "Hindistan",
      strategy: ""
    }
  },
  faq: {
    title: "Sıkça Sorulan Sorular",
    subtitle: "METRADE ve OKX entegrasyonu hakkında sık sorulan soruların cevaplarını bulun",
    question1: {
      question: "OKX-METRADE entegrasyonu nasıl çalışır?",
      answer: "Platformumuz, sadece ticaret izinleri olan güvenli API anahtarları aracılığıyla OKX hesabınıza bağlanır. Bağlandığında, seçtiğiniz stratejiler önceden tanımlanmış parametrelere göre sizin adınıza otomatik olarak işlem yapacaktır."
    },
    question2: {
      question: "Başlamak için gereken minimum sermaye nedir?",
      answer: "Optimum performans için en az 500 USD ile başlamanızı öneriyoruz, ancak 100 USD kadar az bir miktarla da başlayabilirsiniz. Farklı stratejiler, ticaret stillerine bağlı olarak farklı minimum gereksinimlere sahiptir."
    },
    question3: {
      question: "Riskimi nasıl izleyebilir ve kontrol edebilirim?",
      answer: "Her strateji, aktifleştirmeden önce inceleyebileceğiniz yerleşik risk yönetimi ayarlarıyla gelir. Maksimum düşüş limitleri ayarlayabilirsiniz ve bu limitler aşıldığında platformumuz otomatik olarak ticareti durduracaktır."
    },
    question4: {
      question: "Ticaret stratejilerini özelleştirebilir miyim?",
      answer: "Evet, premium kullanıcılar, pozisyon boyutu, maksimum eşzamanlı işlem sayısı ve risk tolerans seviyeleri dahil stratejilerin belirli parametrelerini ayarlayabilir. Temel planlarımız önceden yapılandırılmış stratejiler sunar."
    },
    question5: {
      question: "Bir stratejiyi kullanmayı bırakmak istersem ne olur?",
      answer: "Bir stratejiyi tek tıklamayla istediğiniz zaman duraklatabilir veya bağlantısını kesebilirsiniz. Bu, mevcut açık pozisyonları yönetme seçenekleri sunarken hemen yeni işlemleri durduracaktır."
    },
    question6: {
      question: "Gizli ücretler var mı?",
      answer: "Hayır. Seçtiğiniz plana bağlı olarak şeffaf bir aylık abonelik ücreti alıyoruz. Karlar üzerinde ek komisyonlar veya gizli ücretler yoktur. Sadece standart OKX ticaret ücretlerini ödersiniz."
    }
  },
  footer: {
    copyright: "Tüm hakları saklıdır."
  },
  languageSelector: {
    language: "Dil"
  },
  cta: {
    title: "Ticaretinizi dönüştürmeye hazır mısınız?",
    subtitle: "Bugün 3 aylık ücretsiz deneme ile başlayın",
    buttonText: "Ücretsiz Kaydolun",
    noCredit: "Ücretsiz deneme için kredi kartı gerekmez"
  }
};
